import styled from 'styled-components'

export const Input = styled.input`
  width: 100%;
  height: 40px;
  border: 0.5px solid rgba(88, 88, 88, 0.185);
  padding-left: 20px;
  padding-right: 20px;
  font-family: calibri;
  font-weight: bold;
  font-size: 15px;
  color: rgb(70, 70, 70);
  border-radius: 15px;
  box-shadow: 1px 1px 5px 1px rgb(0 0 0 / 13%);
  outline: none;
  background-color: ${props => props.error && 'pink'};
`
export const FileContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 10px #eee;
  border: 1px solid #eee;
  padding: 2rem;
  background-color: ${props => props.error && 'pink'};
`

export const FileName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FileInput = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  position: relative;
  overflow: hidden;
  background-color: transparent;

  & > button {
    color: #111;
    background-color: white;
    padding: 1rem 1rem;
    border-radius: 8px;
    border: solid 1px #eee;
    font-size: 12px;
    font-weight: bold;
  }

  & > input {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
`

export const Select = styled.select`
  width: 100%;
  height: 40px;
  border: 0.5px solid rgba(88, 88, 88, 0.185);
  padding-left: 20px;
  padding-right: 20px;
  font-family: calibri;
  font-weight: bold;
  font-size: 15px;
  color: rgb(70, 70, 70);
  border-radius: 15px;
  box-shadow: 1px 1px 5px 1px rgb(0 0 0 / 13%);
  background-color: ${props => props.error && 'pink'};
`
export const Datalist = styled.datalist`
  display: none;
`

export const Optionlist = styled.option`
  font-weight: normal;
  display: block;
  white-space: pre;
  min-height: 1.2em;
  padding: 0px 2px 1px;
`

export const Label = styled.label`
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`

export const Wrapper = styled.div`
  position: relative;
`
export const ErrorMessage = styled.span`
  color: red;
  position: absolute;
  left: 0;
  margin-top: 2.8rem;
  font-size: 12px;
  margin-left: 1rem;
  display: ${props => !props.error && 'none'};
`
